import { z } from 'zod';

export const emailSchema = z.string().trim().email();
export const newPasswordSchema = z.string().min(8).max(72);

export const callbackUrl = (next = '/') => `${window.location.origin}/auth/callback?next=${encodeURIComponent(next)}`;
